import { render, staticRenderFns } from "./ClubDetail.vue?vue&type=template&id=6b0cd729&scoped=true"
import script from "./ClubDetail.vue?vue&type=script&lang=js"
export * from "./ClubDetail.vue?vue&type=script&lang=js"
import style0 from "./ClubDetail.vue?vue&type=style&index=0&id=6b0cd729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0cd729",
  null
  
)

export default component.exports